import { useForm } from '@domain-group/react-hooks'

import type { UserModel } from '@domain-group/realhub-backend-api-types'

import useSelector from '@hooks/useSelector'
import useTaskListItem from '@hooks/useTaskListItem'

type UseBulkAssignUserTasksModal = {
  user: UserModel,
}

const defaultFormState = {
  limit: 1,
  task_types: [],
  user_id: undefined,
}

const requiredFields = [
  { key: 'limit' },
  { key: 'task_types', validation: (value: string[]) => !!value.length },
  { key: 'user_id' },
]

function useBulkAssignUserTasksModal(options: UseBulkAssignUserTasksModal) {
  const { user } = options

  const { creating, updating } = useSelector(reduxState => reduxState.taskListItems)

  const entity = {
    user_id: user.id,
  }

  const formPayload = useForm(
    defaultFormState,
    { entity, requiredFields, validateOn: 'change' },
    [user.id],
  )

  const taskListItemPayload = useTaskListItem({ id: undefined })
  const { callbacks: { bulkAssignUserTasks } } = taskListItemPayload

  return {
    callbacks: {
      bulkAssignUserTasks,
    },
    creating,
    formPayload,
    updating,
    user,
  }
}

export default useBulkAssignUserTasksModal
